import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["disabledReasons", "unknownValidationError", "onClickButton", "invoiceId", "hasAllGates"];
import { useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { List } from 'foundations-components/transitional/components/List';
import { actions } from '../../constants/actions';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { usePreloadedInitialInvoiceData } from '../../hooks/usePreloadedInitialInvoiceData';
import { InvoiceOperation } from '../../types/InvoiceOperation';
import { INVOICE_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { jsx as _jsx } from "react/jsx-runtime";
const TooltipWithValidationMessages = ({
  children,
  disabledReasons,
  unknownValidationError
}) => {
  const disabled = !unknownValidationError && disabledReasons.length === 0;
  const headingText = useMemo(() => disabledReasons.length > 0 ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "invoices.components.invoiceActionsDropdown.tooltips.cloneDisabled.headingText"
  }) : null, [disabledReasons]);
  const title = useMemo(() => {
    switch (true) {
      case unknownValidationError:
        {
          return /*#__PURE__*/_jsx(FormattedMessage, {
            message: "invoices.components.invoiceActionsDropdown.tooltips.unknownError.title"
          });
        }
      case disabledReasons.length > 0:
        return /*#__PURE__*/_jsx(List, {
          styled: true,
          wrapChildren: true,
          children: disabledReasons
        });
      default:
        return null;
    }
  }, [unknownValidationError, disabledReasons]);
  return /*#__PURE__*/_jsx(Tooltip, {
    "data-test-id": "tooltip-with-validation-messages",
    disabled: disabled,
    headingText: headingText,
    title: title,
    children: children
  });
};
const CloneInvoiceButton = _ref => {
  let {
      disabledReasons,
      unknownValidationError,
      onClickButton,
      invoiceId,
      hasAllGates
    } = _ref,
    buttonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    preloadedInitialInvoiceData
  } = usePreloadedInitialInvoiceData({
    objectId: invoiceId,
    objectTypeId: INVOICE_TYPE_ID,
    operation: InvoiceOperation.CLONE,
    hasAllGates,
    skip: buttonProps.disabled
  });
  return /*#__PURE__*/_jsx(TooltipWithValidationMessages, {
    disabledReasons: disabledReasons,
    unknownValidationError: unknownValidationError,
    children: /*#__PURE__*/_jsx(Button, {
      onClick: () => onClickButton(actions.CLONE, {
        preloadedInitialInvoiceData
      }),
      "data-test-id": "clone-btn",
      disabled: buttonProps.disabled,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "invoices.components.invoiceActionsDropdown.buttons.clone"
      })
    })
  }, "clone-btn-tooltip");
};
export default CloneInvoiceButton;